export const frases = [
    {
        Frase: 'A melhor maneira de prever o futuro é inventá-lo.'
    }, 
    {
        Frase: 'Se não der certo da primeira vez, chame de versão 1.0.'
    }, 
    {
        Frase: 'A tecnologia só é tecnologia para quem nasceu antes dela ter sido inventada.'
    }, 
    {
        Frase: 'Qualquer tecnologia suficientemente avançada é indistinta de magia.'
    }
]